import { createReducer, on } from '@ngrx/store';
import { setServerTime } from './system.actions';

export interface SystemState {
  serverTime: Date | null;
}

export const initialState: SystemState = {
  serverTime: null
};

export const reducer = createReducer(
  initialState,
  on(setServerTime, (state, { payload }) => ({ ...state, serverTime: payload.serverTime }))
);
